/* ==========================================================================
   Homepage redesign: product carousel tabs + arrows, and the "Find your
   boat" search suggestions. Re-runs when a section is edited in the theme
   editor.
   ========================================================================== */
(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------- Product carousel with tabs ---------------- */
  function initShelf(root) {
    if (root.dataset.oshReady) return;
    root.dataset.oshReady = '1';
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var prev = root.querySelector('[data-osh-prev]');
    var next = root.querySelector('[data-osh-next]');

    var activeTrack = function () {
      var panel = root.querySelector('[role="tabpanel"]:not([hidden])');
      return panel ? panel.querySelector('[data-osh-track]') : null;
    };
    var updateArrows = function () {
      var t = activeTrack();
      if (!prev || !next) return;
      if (!t) { prev.disabled = next.disabled = true; return; }
      prev.disabled = t.scrollLeft < 4;
      next.disabled = t.scrollLeft + t.clientWidth >= t.scrollWidth - 4;
    };
    var select = function (tab) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      var tr = activeTrack();
      if (tr) tr.scrollLeft = 0;
      updateArrows();
    };
    tabs.forEach(function (tab, i) {
      tab.tabIndex = i === 0 ? 0 : -1;
      tab.addEventListener('click', function () { select(tab); });
      tab.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var j = (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        tabs[j].focus(); select(tabs[j]);
      });
    });
    var step = function (dir) {
      var t = activeTrack();
      if (t) t.scrollBy({ left: dir * t.clientWidth * 0.8, behavior: reduceMotion ? 'auto' : 'smooth' });
    };
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    Array.prototype.slice.call(root.querySelectorAll('[data-osh-track]')).forEach(function (t) {
      t.addEventListener('scroll', updateArrows, { passive: true });
    });
    window.addEventListener('resize', updateArrows);
    // Theme editor: clicking a tab block in the sidebar shows that tab.
    root.addEventListener('shopify:block:select', function (e) {
      var tab = e.target.closest && e.target.closest('[role="tab"]');
      if (tab) select(tab);
    });
    updateArrows();
  }

  /* ---------------- Find your boat ---------------- */
  function initFinder(root) {
    if (root.dataset.oshReady) return;
    root.dataset.oshReady = '1';
    var input = root.querySelector('input[type="search"]');
    var list = root.querySelector('.osh-suggest');
    var form = root.querySelector('form');
    if (!input || !list || !form) return;
    if (root.dataset.suggest !== 'true') return;

    var suggestUrl = root.dataset.suggestUrl || '/search/suggest';
    var searchUrl = root.dataset.searchUrl || '/search';
    var limit = parseInt(root.dataset.limit, 10) || 6;
    var allLabel = root.dataset.allLabel || 'See all results for';
    var timer = null, controller = null, active = -1;

    var esc = function (s) {
      return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
    };
    var mark = function (text, words) {
      var out = esc(text);
      words.forEach(function (w) {
        if (!w) return;
        out = out.replace(new RegExp('(' + esc(w).replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig'), '<mark>$1</mark>');
      });
      return out;
    };
    var close = function () { list.hidden = true; input.setAttribute('aria-expanded', 'false'); active = -1; };
    var open = function () { list.hidden = false; input.setAttribute('aria-expanded', 'true'); };

    var render = function (term, products) {
      var words = term.toLowerCase().split(/\s+/);
      var rows = products.map(function (p, i) {
        var img = p.image ? '<img src="' + esc(p.image) + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" width="44" height="44" loading="lazy">' : '';
        return '<li><a role="option" id="' + list.id + '-' + i + '" href="' + esc(p.url) + '">' + img +
          '<span class="osh-suggest__name">' + mark(p.title, words) + '</span></a></li>';
      });
      var allHref = searchUrl + '?type=product&q=' + encodeURIComponent(term);
      rows.push('<li class="osh-suggest__all"><a role="option" id="' + list.id + '-all" href="' + esc(allHref) + '"><span class="osh-suggest__name">' +
        esc(allLabel) + ' “' + esc(term) + '”</span><span class="osh-suggest__k">→</span></a></li>');
      list.innerHTML = rows.join('');
      active = -1;
      open();
    };

    var fetchSuggestions = function () {
      var term = input.value.trim();
      if (term.length < 2) { close(); return; }
      if (controller) controller.abort();
      controller = 'AbortController' in window ? new AbortController() : null;
      var url = suggestUrl + '.json?q=' + encodeURIComponent(term) +
        '&resources[type]=product&resources[limit]=' + limit +
        '&resources[options][unavailable_products]=last';
      fetch(url, controller ? { signal: controller.signal } : {})
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (!data || input.value.trim() !== term) return;
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          render(term, products);
        })
        .catch(function () {});
    };

    var move = function (dir) {
      var items = Array.prototype.slice.call(list.querySelectorAll('a'));
      if (!items.length) return;
      active = (active + dir + items.length) % items.length;
      items.forEach(function (a, i) { a.setAttribute('aria-selected', i === active ? 'true' : 'false'); });
      input.setAttribute('aria-activedescendant', items[active].id);
    };

    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(fetchSuggestions, 180);
    });
    input.addEventListener('focus', function () { if (list.children.length && input.value.trim().length > 1) open(); });
    input.addEventListener('keydown', function (e) {
      if (list.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); move(1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); move(-1); }
      else if (e.key === 'Escape') { close(); }
      else if (e.key === 'Enter' && active >= 0) {
        e.preventDefault();
        window.location.href = list.querySelectorAll('a')[active].href;
      }
    });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
  }

  function initAll() {
    document.querySelectorAll('[data-osh-shelf]').forEach(initShelf);
    document.querySelectorAll('[data-osh-finder]').forEach(initFinder);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
